import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const LOCALES = ["de-DE"];
const CURRENCIES = ["EUR"];

const PriceInfo = (props) => {
  const {
    amount = 0,
    locale = "de-DE",
    currency = "EUR",
    isFreeInAbo = false,
    isEstimated,
    dateExpectedPublication = "",
    datePublication,
    className,
  } = props;
  const componentBaseClass = "sal-price-info";
  const componentClass = classnames(componentBaseClass, className);
  let relevantPublicationDateFormated;
  let priceFormated;

  const relevantPubDate = datePublication
    ? datePublication
    : dateExpectedPublication;

  if (relevantPubDate) {
    try {
      const expectedDate = new Date(relevantPubDate);

      if (!(expectedDate instanceof Date) || isNaN(expectedDate.valueOf())) {
        throw Error(relevantPubDate + " is not a valid Date");
      }

      relevantPublicationDateFormated =
        expectedDate > Date.now()
          ? new Intl.DateTimeFormat(locale, {
              month: "long",
              year: "numeric",
            }).format(expectedDate)
          : null;
    } catch (e) {
      console.error(
        'given date format for "dateExpectedPublication" can not be initialized' +
          e,
      );
    }
  }

  if (amount) {
    priceFormated = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      currencyDisplay: "code",
    }).format(amount / 100);
  } else if (amount === 0) {
    priceFormated = "Gratis";
  }

  return (
    <div className={componentClass}>
      {isFreeInAbo && amount !== 0 && (
        <div className={componentBaseClass + "__hint"}>Im Abo gratis</div>
      )}

      {relevantPublicationDateFormated && (
        <div className={componentBaseClass + "__hint"}>
          Erscheint im {relevantPublicationDateFormated}
        </div>
      )}

      <div className={componentBaseClass + "__price"}>
        {isEstimated && (
          <span className={componentBaseClass + "__price__estimated"}>ca.</span>
        )}
        {priceFormated}
      </div>
    </div>
  );
};

PriceInfo.propTypes = {
  amount: PropTypes.number,
  locale: PropTypes.oneOf(LOCALES),
  currency: PropTypes.oneOf(CURRENCIES),
  isFreeInAbo: PropTypes.bool,
  isEstimated: PropTypes.bool,
  dateExpectedPublication: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  datePublication: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

export default PriceInfo;
